<dashboard-dialog-frame class="search-dialog" header="Finder" [actions]="actions()" [dialogRef]="dialogRef">

	@if(dialogContext.data; as data){
	<div class="d-flex flex-column gap-2 h-100 p-2">
		<algolia-search (searchHits)="algoliaSearchHits = $event" [objectTypes]="data.objectTypes" [searchOnlyForPerson]="data.searchOnlyForPerson"></algolia-search>

		<div>
			<grid-content [setup]="setup()" [namedSize]="'BootstrapDialogContent'" [namedSize]="'CustomHeight'" [customHeight]="customHeight()"
				[rows]="algoliaSearchHits" (selectedRows)="getSelectedRows($event)"></grid-content>
		</div>
	</div>
	}

</dashboard-dialog-frame>